import { LinkButton } from '@/components/Buttons/LinkButton';
import { View } from '@/components/Theme/View';
import { useLayout } from '@/hooks/useContentLayout';
import { useDisclose } from '@/hooks/useDisclose';
import { useThemeColor } from '@/hooks/useThemeColor';
import Fader from '@/utils/Fader';
import { useEffect } from 'react';

export const ExpandableView = (props) => {

    const {isOpen, onOpen} = useDisclose();
    const {maxHeight, children, tintColor = {light: '#ffffff', dark: 'trueGray.1000'}, buttonProps = null, gap = 0,...rest} = props;
    const {layout, setLayout} = useLayout();

    const _tintColor = useThemeColor(tintColor);

    const maxHeightWidthButton = maxHeight - 50;

    useEffect(() => {
        if (layout?.height != null && layout?.height != 0 && layout?.height < maxHeightWidthButton) {
            onOpen();
        }
    }, [layout?.height]);
    
    return (
        <>
            <View 
                maxH={isOpen ? undefined : maxHeightWidthButton} 
                overflow={isOpen ? undefined : 'hidden'} 
                display={isOpen ? 'block': 'flex'}
                {...rest}>
                <View gap={gap} onLayout={(e) => setLayout(e.nativeEvent.layout)}>
                    {children}
                </View>
                {!isOpen && <Fader style={{zIndex: 1}} tintColor={_tintColor} />}
            </View>

            {!isOpen && 
                <LinkButton 
                    borderLess 
                    variant={'outline'} 
                    light={'bmwLightBlue.main'} 
                    dark={'bmwLightBlue.main'} 
                    title={'buttons.show_more'} 
                    onPress={onOpen}
                    {...buttonProps}                    
                />
            }
        </>
    )

};